export const splitDescription = ( string ) => {
    const stringWithoutLineBreaks = string.replace(/\r\n/g, "\n");

    const lines = stringWithoutLineBreaks.split("\n")

    return lines
}